import { createAction } from 'redux-actions';

// Overlay actions
export const overlayOpenStartMenu = createAction('OVERLAY_OPEN_START_MENU');
export const overlayOpenComposeEditor = createAction('OVERLAY_OPEN_COMPOSE_EDITOR');
export const overlayClose = createAction('OVERLAY_CLOSE');

export const startMenuDisplayLogin = createAction('START_MENU_DISPLAY_LOGIN');
export const startMenuDisplaySignup = createAction('START_MENU_DISPLAY_SIGNUP');
export const startMenuDisplayRecover = createAction('START_MENU_DISPLAY_RECOVER');
export const startMenuIsSubmitting = createAction('START_MENU_IS_SUBMITTING');

export const overlayOpenEditorDraftNew = createAction('OVERLAY_OPEN_EDITOR_DRAFT_NEW');
export const composeEditorDraftNew = createAction('COMPOSE_EDITOR_DRAFT_NEW');


// XXX: No longer used, delete
// Notification actions
export const newNotification = createAction('NEW_NOTIFICATION');


// Navs actions (Navbar, Footer)
export const setNavbarVisibility = createAction('SET_NAVBAR_VISIBILITY');
export const setFooterVisibility = createAction('SET_FOOTER_VISIBILITY');



// WEBPACK FOOTER //
// ./src/shared/actions/view/web.js